/* eslint-env browser */

const urlWithoutParameters = (url, parameter) => {
  url = url.trim()
  if (url.endsWith('?')) {
    url = url.slice(0, -1) // last character
  }
  // prefer to use l.search if you have a location/link object
  const urlparts = url.split('?')
  if (urlparts.length >= 2) {
    const prefix = `${parameter}=`
    const pars = urlparts[1].split(/[&;]/g)
    // reverse iteration as may be destructive
    for (let i = pars.length - 1; i >= 0; i--) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    url = urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '')
    return url
  }
  return url
}

export const removeURLParameter = key => {
  if (window.history.pushState) {
    let currentUrl = window.location.href
    // remove any param for the same key
    currentUrl = urlWithoutParameters(currentUrl, key)
    window.history.pushState({ path: currentUrl }, '', currentUrl)
  }
}

export const computeTargetURLWithParameter = ({ host, path, queryParams = {} }) => {
  let currentUrl = host + path

  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key]
    if (value && value.length > 0) {
      let queryStart = '?'
      if (currentUrl.indexOf('?') !== -1) {
        queryStart = '&'
      }
      currentUrl = `${currentUrl + queryStart + key}=${value}`
    }
  })
  return currentUrl
}

export const URLByAddingParameter = (url, { key, value }) => {
  let hashtags
  if (url.includes('#')) {
    ;[url, hashtags] = url.split('#')
  }

  const currentUrl = urlWithoutParameters(url, key)

  let queryStart = ''
  if (value && value.length > 0) {
    // figure out if we need to add the param with a ? or a &
    if (currentUrl.indexOf('?') !== -1) {
      queryStart = '&'
    } else {
      queryStart = '?'
    }
  }
  let newurl = `${currentUrl}`
  if (value && value.length > 0) {
    newurl = `${newurl + queryStart + key}=${value}`
  }
  if (hashtags) {
    newurl = `${newurl}#${hashtags}`
  }
  return newurl
}

export const insertURLParameter = (key, value) => {
  if (window.history.pushState) {
    let currentUrl = window.location.href
    // remove any param for the same key
    currentUrl = urlWithoutParameters(currentUrl, key)

    let queryStart = ''
    if (value && value.length > 0) {
      // figure out if we need to add the param with a ? or a &
      if (currentUrl.indexOf('?') !== -1) {
        queryStart = '&'
      } else {
        queryStart = '?'
      }
    }
    let newurl = `${currentUrl}`
    if (value && value.length > 0) {
      newurl = `${newurl + queryStart + key}=${value}`
    }
    window.history.pushState({ path: newurl }, '', newurl)
  }
}
